import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onUnmounted, ref } from 'vue';

import {
  FilterList,
  LoaderIndicator,
  HelperViewStatus,
  DataTable,
  ButtonIconPrimary
} from '@warrenbrasil/nebraska-web';

import { registerObserver } from '@/modules/catalog/views/Products/helpers/registerObserver';
import { columns } from './columns';
import {
  getGovernmentBondProducts,
  IGovernmentBondProduct,
  IGovernmentBondFilter,
  IPagination,
  IGovernmentBondParams
} from '@/modules/catalog/services/products';

interface Props {
  isBuilder: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GovernmentBondProducts',
  props: {
    isBuilder: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isBuilder: boolean;
}



const products = ref<IGovernmentBondProduct[]>([]);
const filters = ref<IGovernmentBondFilter>();
const pagination = ref<IPagination>();
const params = ref<IGovernmentBondParams>({
  pageIndex: 1,
  pageSize: 10,
  segmentIds: '0'
});

const selectedFilter = ref('0');

const isLoading = ref(true);
const isScrolling = ref(false);
const isSorting = ref(false);
const hasError = ref(false);

const scrollTop = ref(document.documentElement.scrollTop);

const columnsTable = computed(() => {
  return columns(pagination.value!.totalRecords);
});

const hasScrolled = computed(() => {
  return scrollTop.value >= 100;
});

const scrolledButtonClass = computed(() => {
  return props.isBuilder
    ? 'government-bond-products__button builder'
    : 'government-bond-products__button';
});

async function applyFilter(applyedFilter: string | number) {
  params.value = {
    pageSize: 10,
    pageIndex: 1,
    segmentIds: String(applyedFilter)
  };

  await fetchGovernmentBondProducts();
  registerObserver(fetchGovernmentBondProducts);
}

async function onSort(index: number, isSort: boolean, value: string) {
  const sortDirection =
    index === -1 ? undefined : isSort ? 'Ascending' : 'Descending';
  const sortField = index === -1 ? undefined : value;

  params.value = {
    ...params.value,
    pageIndex: 1,
    sortField,
    sortDirection
  };

  await fetchGovernmentBondProducts(false, false, true);
  registerObserver(fetchGovernmentBondProducts);
}

async function retry() {
  await fetchGovernmentBondProducts();
  registerObserver(fetchGovernmentBondProducts);
}

function goToTop() {
  document.documentElement.scrollTo(0, 0);
}

async function fetchGovernmentBondProducts(
  loading = true,
  scrolling = false,
  sorting = false
) {
  try {
    isLoading.value = loading;
    isScrolling.value = scrolling;
    isSorting.value = sorting;
    hasError.value = false;

    if (isScrolling.value) {
      if (!pagination.value?.nextPage) return;

      params.value = {
        ...params.value,
        pageIndex: pagination.value.nextPage
      };
    }

    const data = await getGovernmentBondProducts(params.value);

    filters.value = data.filters;
    pagination.value = data.pagination;

    if (isScrolling.value) {
      products.value.push(...data.items);
      return;
    }

    products.value = data.items;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
    isScrolling.value = false;
    isSorting.value = false;
  }
}

function handleScrollTop() {
  scrollTop.value = document.documentElement.scrollTop;
}

onBeforeMount(async () => {
  await fetchGovernmentBondProducts();

  window.addEventListener('scroll', handleScrollTop);

  registerObserver(fetchGovernmentBondProducts);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScrollTop);
});

return { __sfc: true,props, products, filters, pagination, params, selectedFilter, isLoading, isScrolling, isSorting, hasError, scrollTop, columnsTable, hasScrolled, scrolledButtonClass, applyFilter, onSort, retry, goToTop, fetchGovernmentBondProducts, handleScrollTop, FilterList, LoaderIndicator, HelperViewStatus, DataTable, ButtonIconPrimary }
}

})